// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { SvResponse, Sv, SvListTableData, Embedded } from '../../../interfaces/hce/hce-sv';
import { makeGenesNameLinks } from '../hce-parser-adapter';

export function mapSvToTableRow(sv: Sv, svsKeyRaw: string): SvListTableData {
  const chr = sv.region?.chr;
  const segTo = sv.segment_to;
  const svsKeyNum = Number.isFinite(parseInt(svsKeyRaw, 10)) ? parseInt(svsKeyRaw, 10) : -1;

  return {
    svsKey: svsKeyNum,
    svId: sv.hce_sv_id,
    chrId: sv.chr_id,
    start: chr?.start?.min ?? null,
    end: chr?.end?.max ?? null,
    length: sv.length ?? null,
    chrToId: sv.chr_to_id ?? null,
    startTo: segTo?.start?.min ?? null,
    endTo: segTo?.end?.max ?? null,
    lengthTo: segTo?.length ?? null,
    type: sv.type,
    contig: sv.contig_id != null ? String(sv.contig_id) : null,
    zygosity: sv.zygosity,
    flaggedSv: sv.Embedded ?? Embedded.N,
    genename: chr?.affected_genes ?? [],
    genenameTo: segTo?.affected_genes ?? [],
    geneLinks: makeGenesNameLinks(
      chr?.affected_genes,
      chr?.affected_genes_hrefs
    ) ?? [],
    geneLinksTo: makeGenesNameLinks(
      segTo?.affected_genes,
      segTo?.affected_genes_hrefs
    ) ?? [],
    minimumIntervalDepth: sv.region_frags_info?.region_aggregated_stats?.coverage?.min ?? null,
    medianIntervalDepth:  sv.region_frags_info?.region_aggregated_stats?.coverage?.median ?? null,
    qualityScore: sv.quality_score ?? null,
    reason: sv.reason ?? null,
    molCheck: sv.lytx?.mol_check ?? null,
    colorSdb: sv.lytx?.percent_presence_lrs_cohort ?? null,
    gnomAd: sv.lytx?.percent_presence_gnomad_cohort ?? null,
    ontLrs: sv.lytx?.percent_presence_ont_cohort ?? null,
    masked: sv.lytx?.masked ?? null,
    bestSvPerCluster: sv.lytx?.rep_sv_in_cluster ?? null,
  };
}

export function mapSvResponseToTableRows(res: SvResponse | null | undefined): SvListTableData[] {
  if (!res?.svs) return [];
  return Object.entries(res.svs).map(([svsKey, sv]) => mapSvToTableRow(sv, svsKey));
}
